import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    productSegment: {
        isLoading: false,
        data:[],
        error: null
    },
    attributeData: {
        isLoading: false,
        data: [],
        error: null
    },
    newCampaign: {
        isLoading: false,
        data: null,
        error: null
    },
    activeStep: 0,
    viewCampaignSelected: null,
    targetCustomerCount: null,
    customerCountLoading: false,
    customerCountError: null,
    isValidNext: false,
    step2MissingValue: {
        isRemovedValue: false,
        message:''
    },
    step3MissingValue: {
        isRemovedValue: false,
        message:''
    },
    isClone: false,
};

const createCampaignSlice = createSlice({
    name: 'CreateCampaign',
    initialState,
    reducers: {
        getProductSegment: (state) => {
            state.productSegment.isLoading = true;
        },
        getProductSegmentSuccess: (state, action) => {
            state.productSegment.isLoading = false;
            state.productSegment.data = action.payload.attributesOperatorsValues
        },
        // Use the PayloadAction type to declare the contents of `action.payload`
        getProductSegmentError: (state, action) => {
            state.productSegment.isLoading = false;
            state.productSegment.error = action.payload;
        },
        getAttributes: (state) => {
            state.attributeData.isLoading = true;
        },
        getAttributesSuccess: (state, action) => {
            state.attributeData.isLoading = false;
            state.attributeData.data = action.payload.attributesOperatorsValues;
        },
        // Use the PayloadAction type to declare the contents of `action.payload`
        getAttributesError: (state, action) => {
            state.attributeData.isLoading = false;
            state.attributeData.error = action.payload;
        },
        setStep: (state, action) => {
            state.activeStep = action.payload;
        },
        createNewCampaign: (state) => {
            state.newCampaign.isLoading = true;
        },
        createNewCampaignSuccess: (state, action) => {
            state.newCampaign.isLoading = false;
            state.newCampaign.data = action.payload;
        },
        // Use the PayloadAction type to declare the contents of `action.payload`
        createNewCampaignError: (state, action) => {
            state.newCampaign.isLoading = false;
            state.newCampaign.error = action.payload.message;
        },
        setViewCampaignSelected: (state, action) => {
            state.viewCampaignSelected = action.payload;
        },
        getCustomerCount: (state, action) => {
            state.customerCountLoading = true;
            state.targetCustomerCount = null;
        },
        setTargetCustomerCount: (state, action) => {
            state.targetCustomerCount = action.payload;
            state.customerCountLoading = false;
        },
        getCustomerCountError: (state, action) => {
            state.customerCountLoading = false;
            state.customerCountError = action.payload;
        },
        isValidForNext: (state,action) => {
            state.isValidNext = action.payload
        },
        setStep2MissingValue: (state,action) => {
            state.step2MissingValue.isRemovedValue = true
            state.step2MissingValue.message = action.payload
        },
        resetStep2MissingValue: (state) => {
            state.step2MissingValue.isRemovedValue = false
            state.step2MissingValue.message = ''
        },
        setStep3MissingValue: (state,action) => {
            state.step3MissingValue.isRemovedValue = true
            state.step3MissingValue.message = action.payload
        },
        resetStep3MissingValue: (state) => {
            state.step3MissingValue.isRemovedValue = false
            state.step3MissingValue.message = ''
        },
        setIsClone: (state, action) => {
            state.isClone = action.payload
        }
    },
});

export const {
    getProductSegment,
    getProductSegmentError,
    getProductSegmentSuccess,
    getAttributes,
    getAttributesSuccess,
    getAttributesError,
    createNewCampaign,
    createNewCampaignSuccess,
    createNewCampaignError,
    setViewCampaignSelected,
    setTargetCustomerCount,
    getCustomerCount,
    getCustomerCountError,
    setStep,
    isValidForNext,
    setStep2MissingValue,
    resetStep2MissingValue,
    setStep3MissingValue,
    resetStep3MissingValue,
    setIsClone
} = createCampaignSlice.actions;

export default createCampaignSlice.reducer;
